import * as React from "react";
import { Card } from "../../card/card/card.mjs";
import { CardContent } from "../../card/card-content/card-content.mjs";
import { Check } from "../check/check.mjs";
import { FormHelper } from "../form-helper/form-helper.mjs";
import { PropsChecker } from "../../helpers/props-checker/props-checker.mjs";
import { Radio } from "../radio/radio.mjs";
function getInitialValue(type, defaultValue) {
  if (defaultValue) {
    return defaultValue;
  } else if (type === "check") {
    return [];
  } else {
    return null;
  }
}
const ChoiceGroup = (props) => {
  return /* @__PURE__ */ React.createElement(PropsChecker, { componentName: "ChoiceGroup", componentProps: props, defaultValueName: "defaultValue", valueName: "value", onChangeNames: "onChange" }, /* @__PURE__ */ React.createElement(ChoiceGroupInner, { ...props }));
};
const ChoiceGroupInner = (props) => {
  const [innerValue, setInnerValue] = React.useState(getInitialValue(props.type, props.defaultValue));
  const currentValue = props.onChange && typeof props.value !== "undefined" ? props.value : innerValue;
  const isInvalid = props.isInvalid || !!props.errorMessage;
  function getNextValue(value, checked) {
    if (props.type === "check" && Array.isArray(currentValue)) {
      if (checked) {
        return [...currentValue, value];
      } else {
        return currentValue.filter((item) => item !== value);
      }
    } else {
      return value;
    }
  }
  function onChange(value, checked, onChange2) {
    if (typeof props.value === "undefined") {
      setInnerValue(getNextValue(value, checked));
    }
    if (props.onChange) {
      props.onChange(getNextValue(value, checked));
    }
    if (onChange2) {
      onChange2(checked);
    }
  }
  function isChecked(value) {
    if (currentValue === null) {
      return false;
    }
    if (props.type === "check") {
      return value === currentValue || currentValue.indexOf(value) !== -1;
    } else {
      return value === currentValue;
    }
  }
  const getAriaDescribedBy = (inputAriaDescribedby) => {
    const arr = [];
    if (props.helpMessage) {
      arr.push("".concat(props.id, "-help-message"));
    }
    if (props.errorMessage) {
      arr.push("".concat(props.id, "-error-message"));
    }
    if (props.successMessage) {
      arr.push("".concat(props.id, "-success-message"));
    }
    if (props.employeeMessage) {
      arr.push("".concat(props.id, "-employee-message"));
    }
    if (inputAriaDescribedby) {
      arr.push(inputAriaDescribedby);
    }
    return arr.join(" ");
  };
  function getChildren() {
    if (props.children) {
      return React.Children.toArray(props.children).filter((child) => {
        return React.isValidElement(child) && (child.type === Check || child.type === Radio);
      }).map((child) => {
        const { props: childProps } = child;
        if ("skeleton" in childProps) {
          return child;
        }
        return React.cloneElement(child, {
          key: childProps.id,
          checked: isChecked(childProps.value),
          className: childProps.className,
          onChange: (checked) => onChange(childProps.value, checked, childProps.onChange),
          "aria-invalid": isInvalid,
          "aria-describedby": getAriaDescribedBy(childProps["aria-describedby"])
        });
      });
    }
    if (!props.options) {
      return [];
    }
    return props.options.map((item) => {
      if (props.type === "check") {
        if ("skeleton" in item) {
          return /* @__PURE__ */ React.createElement(Check, { ...item, key: item.id, "aria-invalid": isInvalid, "aria-describedby": getAriaDescribedBy(item["aria-describedby"]) });
        }
        return /* @__PURE__ */ React.createElement(
          Check,
          {
            ...item,
            checked: isChecked(item.value),
            onChange: (checked) => onChange(item.value, checked, item.onChange),
            key: item.id,
            "aria-invalid": isInvalid,
            "aria-describedby": getAriaDescribedBy(item["aria-describedby"])
          }
        );
      }
      if ("skeleton" in item) {
        return /* @__PURE__ */ React.createElement(Radio, { ...item, key: item.id, "aria-invalid": isInvalid, "aria-describedby": getAriaDescribedBy(item["aria-describedby"]) });
      }
      return /* @__PURE__ */ React.createElement(
        Radio,
        {
          ...item,
          checked: isChecked(item.value),
          onChange: (checked) => onChange(item.value, checked, item.onChange),
          key: item.id,
          "aria-invalid": isInvalid,
          "aria-describedby": getAriaDescribedBy(item["aria-describedby"])
        }
      );
    });
  }
  const BEM = () => {
    const classArray = ["choice-group"];
    if (props.display) {
      classArray.push("choice-group--".concat(props.display));
    }
    if (props.align) {
      classArray.push("choice-group--".concat(props.align));
    }
    if (props.hideLabel) {
      classArray.push(props.hideLabel === true ? "choice-group--no-label-no-break" : "choice-group--no-label-".concat(props.hideLabel));
    }
    if (isInvalid) {
      classArray.push("is-invalid");
    }
    if (props.className) {
      classArray.push(props.className);
    }
    return classArray.join(" ");
  };
  const labelBEM = () => {
    var _a;
    const classArray = ["choice-group__label", (_a = props.labelSize) != null ? _a : "h6"];
    if (props.labelClass) {
      classArray.push(props.labelClass);
    }
    return classArray.join(" ");
  };
  return /* @__PURE__ */ React.createElement(
    "fieldset",
    {
      className: BEM(),
      id: props.id,
      role: props.type === "radio" ? "radiogroup" : void 0,
      "aria-required": props.type === "radio" ? props.required : void 0
    },
    /* @__PURE__ */ React.createElement("legend", { className: labelBEM() }, props.label),
    props.helpMessage && /* @__PURE__ */ React.createElement(FormHelper, { text: props.helpMessage, type: "help", id: "".concat(props.id, "-help-message") }),
    props.errorMessage && /* @__PURE__ */ React.createElement(FormHelper, { text: props.errorMessage, type: "error", id: "".concat(props.id, "-error-message") }),
    props.successMessage && /* @__PURE__ */ React.createElement(FormHelper, { text: props.successMessage, type: "valid", id: "".concat(props.id, "-success-message") }),
    props.employeeMessage && /* @__PURE__ */ React.createElement(FormHelper, { text: props.employeeMessage, type: "employee", id: "".concat(props.id, "-employee-message") }),
    props.purpose === "agreement" ? /* @__PURE__ */ React.createElement(Card, { type: isInvalid ? "error" : void 0, background: props.background, className: "choice-group__inner-card" }, /* @__PURE__ */ React.createElement(CardContent, { className: "choice-group__inner" }, getChildren())) : /* @__PURE__ */ React.createElement("div", { className: "choice-group__inner" }, getChildren())
  );
};
export {
  ChoiceGroup
};
